module.exports = __webpack_public_path__ + "img/step35_a_printer_power_fix_printer_right_side - Copy.0a0344ec.png";